import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from '../locales/en/translation.json';
import translationDE from '../locales/de/translation.json';
const resources = {
  en: {
    translation: translationEN
  },
  de: {
    translation: translationDE
  },
};
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, 
    },
    returnObjects: true, 
    detection: {
      order: ['cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['cookie'], 
      cookieMinutes: 10, 
      cookieDomain: window.location.hostname, 
    },
    resources
  });

export default i18n;